import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField
} from "@mui/material";
import { styled } from "@mui/system";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section6 = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  useEffect(() => {
    const categories = ["in_fellowship", "not_in_fellowship"];
    // Calculate all totals in one go to batch the updates
    const updates = categories.reduce((acc, category) => {
      const male = Number(formState.homeFellowship[category].male) || 0;
      const female = Number(formState.homeFellowship[category].female) || 0;
      const total = male + female;
      if (total !== formState.homeFellowship[category].total) {
        acc[category] = {
          ...formState.homeFellowship[category],
          total
        };
      }
      return acc;
    }, {});
    // Only update if there are changes
    if (Object.keys(updates).length > 0) {
      handleChange("homeFellowship", "all", {
        ...updates
      });
    }
  }, [
    formState.homeFellowship.in_fellowship.male,
    formState.homeFellowship.in_fellowship.female,
    formState.homeFellowship.not_in_fellowship.male,
    formState.homeFellowship.not_in_fellowship.female
  ]);

  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>አጥቢያይቱ ያላት የቤት ህብረት ብዛት</TableCell>
              <TableCell colSpan={3}>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.homeFellowship.total}
                  onValueChange={values => {
                    handleChange("homeFellowship", "total", values.floatValue);
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
              <TableCell align="center">ድምር</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በቤት ሕብረት የታቀፉ ምዕመናን ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.homeFellowship.in_fellowship.male}
                  onValueChange={values => {
                    handleChange("homeFellowship", "in_fellowship", {
                      ...formState.homeFellowship.in_fellowship,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.homeFellowship.in_fellowship.female}
                  onValueChange={values => {
                    handleChange("homeFellowship", "in_fellowship", {
                      ...formState.homeFellowship.in_fellowship,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.homeFellowship.in_fellowship.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በቤት ሕብረት ያልታቀፉ ምዕመናን ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.homeFellowship.not_in_fellowship.male}
                  onValueChange={values => {
                    handleChange("homeFellowship", "not_in_fellowship", {
                      ...formState.homeFellowship.not_in_fellowship,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.homeFellowship.not_in_fellowship.female}
                  onValueChange={values => {
                    handleChange("homeFellowship", "not_in_fellowship", {
                      ...formState.homeFellowship.not_in_fellowship,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.homeFellowship.not_in_fellowship.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(7)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
